export default __webpack_public_path__ + "static/happy-ed581cb4e51e28ab15df44bb9acbe22a.gif";